module.exports = __webpack_public_path__ + "static/media/15_LeoTeichmann_webfinal.8fb6ddf6.jpg";